import { useEffect, useState } from 'react';
import Header from './components/Header';
import HeroNew from './components/HeroNew';
import KairosCore from './components/KairosCore';
import WorkingExamples from './components/WorkingExamples';
import WhatMakesDifferentNew from './components/WhatMakesDifferentNew';
import './App.css';

function App() {
  const [restaurantName, setRestaurantName] = useState('');
  const [restaurantSlug, setRestaurantSlug] = useState('');
  const [hasSlugParam, setHasSlugParam] = useState(false);
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    
    // Handle 'restaurant', 'slug', and 'hotel' parameters
    const restaurant = params.get('restaurant');
    const slug = params.get('slug');
    const hotel = params.get('hotel');
    
    if (restaurant) {
      setHasSlugParam(true);
      setRestaurantSlug(restaurant.toLowerCase());
      // Convert slug to restaurant name (replace underscores/hyphens with spaces, capitalize)
      const restaurantName = restaurant.replace(/[_-]/g, ' ').split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ') + ' Restaurant';
      setRestaurantName(restaurantName);
    } else if (slug) {
      setHasSlugParam(true);
      setRestaurantSlug(slug.toLowerCase());
      // Convert slug to restaurant name
      const restaurantName = slug.replace(/[_-]/g, ' ').split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ') + ' Restaurant';
      setRestaurantName(restaurantName);
    } else if (hotel) {
      setHasSlugParam(true);
      setRestaurantSlug(hotel.toLowerCase());
      setRestaurantName(hotel.charAt(0).toUpperCase() + hotel.slice(1) + ' Hotel');
    } else {
      setHasSlugParam(false);
      setRestaurantName('Your Restaurant');
      setRestaurantSlug('demo');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Header />
      
      {/* Add padding to account for fixed header */}
      <div className="pt-16">
        <HeroNew restaurantName={restaurantName} restaurantSlug={restaurantSlug} hasSlugParam={hasSlugParam} />
        <KairosCore />
        <WorkingExamples />
        <WhatMakesDifferentNew />
      </div>
    </div>
  );
}

export default App;